var _a;
import { Sports } from 'common/enums/sport/sports.enum';
export var SportIds = (_a = {},
    _a[Sports.Run] = '0928af54-3c15-48f7-8192-a57b3f1b2a77',
    _a[Sports.Ride] = 'b71dfbcd-cae7-4588-b8cd-cb6cd85067b5',
    _a[Sports.Skiing] = '5e9fd77e-449b-4483-bbf2-88cc892d6d41',
    _a[Sports.Swimming] = '9f898049-3b3e-4666-bb06-ef935d135a14',
    _a[Sports.Unknown] = '64908c46-8569-4d00-af0f-225106161bb9',
    _a[Sports.Walking] = 'e9df3414-5c76-47cc-9435-922559463aac',
    _a);
